import ValidService from "../../../service/ValidService";

let model = {};

// dữ liệu form
model.dataForm = {
    "name": undefined, // required Tên kỳ lương
    "company_id": undefined, // required Mã công ty
    "template_salary_period_id": undefined, // required Template kỳ lương
    "from_date": undefined, // required Từ ngày
    "before_to_date": undefined, // required Tới trước ngày
    "sealed": undefined, // required Đã chốt chưa
    "is_sequential": true, // required Có tuần tự hay không
    "sealed_level": undefined, // required Cấp độ duyệt
    "sealed_users": [ // optional Danh sách người Chốt
    {
        "sealed_user_id": undefined, // required Người chốt
        "sealed_at": undefined, // optional Thời điểm chốt
        "is_sealed": undefined, // optional Chốt/Không chốt
    }],
    "file_id": null, // optional File lương
    "tax_file_id": null, // optional, ref: mushroom_file - File thuế
    "insurance_file_id": null, // optional, ref: mushroom_file - File bảo hiểm
    "created_at": undefined, // required Thời điểm tạo
    "created_user_id": undefined, // required Người tạo
};

// validation form
model.validForm = {
    "name": [
                ValidService.required,
                ValidService.checkSpaceString,
                ValidService.checkVietNameseHaveNumber,
                ValidService.checkMaxLength(30)
            ], // required Tên kỳ lương
    "company_id": [], // required Mã công ty
    "template_salary_period_id": [ValidService.required, ValidService.requiredChange], // required Template kỳ lương
    "department_ids": [], // optional Phòng ban Ids
    "from_date": [ValidService.required, ValidService.requiredChange], // required Từ ngày
    "before_to_date": [ValidService.required, ValidService.requiredChange], // required Tới trước ngày
    "sealed": [ValidService.required], // required Đã chốt chưa
    "is_sequential": [], // required Có tuần tự hay không
    "sealed_level": [ValidService.required, ValidService.requiredChange], // required Cấp độ duyệt
    "file_id": [],
    "tax_file_id": [],
    "insurance_file_id": [],
    "sealed_users": // optional Danh sách người Chốt
    [],
    "created_at": [], // required Thời điểm tạo
    "created_user_id": [], // required Người tạo
};

// dữ liệu mẫu các form khác
model.dataFormOther = {};

// validation các form khác
model.validFormOther = {};


model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["", "ascending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {},
        valid: {},
        operator: {}
    }
};

export default model;
